import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext.jsx";

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export default function SuccessPage() {
  const navigate = useNavigate();
  const { order, setOrder } = useOrder();
  const { state } = useLocation();

  // Reached only via a successful payment, which leaves the order in context.
  // Direct hits / refreshes have nothing to confirm — send them to sign up.
  if (!order) {
    return <Navigate to="/" replace />;
  }

  function handleDone() {
    setOrder(null);
    navigate("/");
  }

  return (
    <section className="card card--center">
      <div className="success__check" aria-hidden="true">
        ✓
      </div>
      <h2 className="card__title">Payment successful</h2>
      <p className="card__subtitle">
        Thanks, {order.name} — your payment has been processed.
      </p>

      <dl className="summary">
        <div className="summary__row">
          <dt className="summary__label">Amount paid</dt>
          <dd className="summary__value">{usd.format(order.amount)}</dd>
        </div>
        <div className="summary__row">
          <dt className="summary__label">Email</dt>
          <dd className="summary__value">{order.email}</dd>
        </div>
        {state?.paymentIntentId && (
          <div className="summary__row">
            <dt className="summary__label">Reference</dt>
            <dd className="summary__value">{state.paymentIntentId}</dd>
          </div>
        )}
      </dl>

      <button className="btn" type="button" onClick={handleDone}>
        Done
      </button>
    </section>
  );
}
